import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import type {
  TabModel,
  Layout,
  Partial,
  LinkModel,
  CalendarMetadata,
  DateBarViewType,
  ViewComponentMetadata,
  SectionModel,
  FilterModel,
  SearchModel
} from '@flocasts/experience-service-types'
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap'
import { createNgbDateStruct } from '../../../date-filters/date-picker/date-picker.functions'
import { FilterOptionModel } from '@flocasts/experience-service-types'

/**
 * This component combines date-bar, date-picker and search to be reused across lists of events
 */
@Component({
  selector: 'flo-event-list-controls',
  templateUrl: './event-list-controls.component.html',
  styleUrls: ['./event-list-controls.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventListControlsComponent {
  public selectedDate: NgbDateStruct | null
  public action: LinkModel | null
  public dateMode: DateBarViewType | null

  @Input()
  set calendarAction(action: LinkModel | null) {
    if (action) {
      this.action = action
      if (EventListControlsComponent.isCalendarMetadata(action.contentMetadata)) {
        this.dateMode = action.contentMetadata.dateMode
      }
    }
  }
  @Input() filtersSection: SectionModel<FilterModel | LinkModel> | null

  /** Used to clear out all [clearable] filters */
  @Input() clearAll: LinkModel
  @Input() searchTerm: string
  @Input() tabItems: TabModel<Layout | Partial | null>[] | LinkModel[] | undefined
  /** Show toggle for favorites */
  @Input() toggleFilter: FilterModel | null
  /* Convert YYYY-mm-dd string into NgbDateStruct */
  @Input()
  set dateSelected(formattedDate: string | null) {
    if (formattedDate) {
      this.selectedDate = createNgbDateStruct(formattedDate)
    }
  }
  @Output() navigateToTab = new EventEmitter<string>()
  @Output() search = new EventEmitter<string | null>()
  @Output() singleFilterClicked = new EventEmitter<string | null>()

  public handleSearch(event: { searchTerm: string | null; searchModel?: SearchModel | null }) {
    this.search.emit(event.searchTerm)
  }

  public datePickerSelected(dateSelected: { formattedDate: string; day: number; month: number; year: number }) {
    this.navigateToTab.emit(dateSelected.formattedDate)
  }

  static isCalendarMetadata(metadata: ViewComponentMetadata | null): metadata is CalendarMetadata {
    return !!metadata && 'dateMode' in metadata
  }

  public handleSingleFilterClicked(option: FilterOptionModel) {
    this.singleFilterClicked.emit(option.facets)
  }
}
